import React, { useEffect, useState } from "react";
import L from "leaflet";
import { MapContainer, TileLayer, CircleMarker, Polygon, Tooltip, Popup, Circle, Marker, ZoomControl } from "react-leaflet";
import { fetchPointControlsByYardApi, GetPerimeterYard, GetYardById } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { colorMaps, iconAltoPng, iconMedioPng, iconBajoPng, tipoIncidencia } from "../util/util";

const createIncidentIcon = (iconUrl) => L.icon({
    iconUrl,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -32],
    tooltipAnchor: [0, -32],
});

const INCIDENT_ICONS = {
    1: createIncidentIcon(iconBajoPng),
    2: createIncidentIcon(iconMedioPng),
    3: createIncidentIcon(iconAltoPng),
};

const DEFAULT_INCIDENT_ICON = INCIDENT_ICONS[1];

export default function MapLeaflet({ incidentObject }) {
    console.log(incidentObject)
    const { token } = useAuth();
    const [yard, setYard] = useState(null);
    const [perimetro, setPerimetro] = useState([]);
    const [puntosControl, setPuntosControl] = useState([]);

    const [error, setError] = useState(null);

    useEffect(() => {
        if (!incidentObject.yardId) {
            setYard(null);
            return;
        }

        let cancelled = false;

        (async () => {
            try {
                const data = await GetYardById({ yardId: incidentObject.yardId, token });
                const dataPerimetros = await GetPerimeterYard({ yardId: incidentObject.yardId, token });
                const dataPuntosControl = await fetchPointControlsByYardApi(incidentObject.yardId, { token });
                setPuntosControl(Array.isArray(dataPuntosControl) ? dataPuntosControl : []);

                setPerimetro(
                    (Array.isArray(dataPerimetros) ? dataPerimetros : [])
                        .sort((a, b) => a.order - b.order)
                        .map(p => [p.latitude, p.longitude])
                );
                if (!cancelled) {
                    setYard(data || null);
                    setError(null);
                }
            } catch (err) {
                if (!cancelled) {
                    console.error("Failed to fetch yard", err);
                    setYard(null);
                    setError(err?.message || "No se pudo cargar el patio");
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [incidentObject.yardId, token]);

    const lat = yard?.latitude != null ? Number(yard.latitude) : null;
    const lng = yard?.longitude != null ? Number(yard.longitude) : null;
    const hasCoords = Number.isFinite(lat) && Number.isFinite(lng);

    if (!incidentObject.yardId) {
        return <div className="text-center text-muted py-4">Selecciona una incidencia para ver el mapa</div>;
    }

    if (error) {
        return <div className="text-center text-danger py-4">{error}</div>;
    }

    if (!hasCoords) {
        return <div className="text-center text-muted py-4">Este patio no tiene coordenadas registradas</div>;
    }

    const incidentLevel = Number(incidentObject.levelIncident);
    const markerIcon = INCIDENT_ICONS[incidentLevel] || DEFAULT_INCIDENT_ICON;

    return (
        <MapContainer
            key={incidentObject.id}
            center={[lat, lng]}
            zoom={18}
            maxZoom={22}
            zoomControl={false}

            style={{ height: 500, width: '100%' }}
            scrollWheelZoom
        >
            <ZoomControl position="topright" />

            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
            />
            <Polygon positions={perimetro}
                pathOptions={{
                    color: 'blue',
                    weight: 2,
                    fillOpacity: 0.1,
                    fillColor: colorMaps.perimeterFill,
                }}
            />
            {puntosControl.map((pc, index) => (
                <Circle
                    key={pc.id || index}
                    center={[pc.latitude, pc.longitude]}
                    radius={pc.geozoneRadio}
                    pathOptions={{
                        color: colorMaps.zoneStroke,
                        fillOpacity: 0.15,
                        weight: 2.5,
                        fillColor: colorMaps.zoneFill,
                    }}
                >
                    <Popup>
                        <div className="d-flex flex-column align-items-center text-center gap-2">
                            <strong className="h6">{pc.name}</strong>
                            <span className="h6">Radio: {pc.geozoneRadio}m</span>
                            <span className="h6">Lat: {pc.latitude}</span>
                            <span className="h6">Lng: {pc.longitude}</span>
                        </div>
                    </Popup>
                    <CircleMarker
                        center={[pc.latitude, pc.longitude]}
                        radius={5}
                        pathOptions={{
                            color: colorMaps.zoneCenter,
                            weight: 2,
                            fillOpacity: 1,
                            fillColor: colorMaps.zoneCenter,
                        }}
                    />
                    <Tooltip
                        permanent
                        interactive={false}
                        direction="bottom"
                        offset={[0, 12]}
                        className="pc-label"
                        opacity={1}
                    >
                        <p className="text-center fs-5 fw-semibold"> {pc.order}. {pc.name}</p>
                    </Tooltip>

                </Circle>
            ))}

            <Marker
                key={incidentObject.id}
                position={[incidentObject.latitude || 0, incidentObject.longitude || 0]}
                icon={markerIcon}
            >
                <Popup>
                    <div className="text-center">
                        <h5>  {tipoIncidencia(incidentObject.typeIncident)}</h5>
                        <p className="fs-6 text-muted">
                            {incidentObject.description}
                        </p>
                    </div>
                </Popup>

            </Marker>
        </MapContainer>
    );
}
